import Logo from "../assets/Images/ejobs-logo2.svg";
import { Copyright, SocialLinks } from "./Footer/data";
import useUserStat from "../hooks/useUserStat";
import { useState } from "react";
import { STAT_PASSWORD } from "../config/config";
import StatsForm from "./stats/StatsForm";
import Statistics from "./stats/Statistics";
import { Link } from "react-router-dom";

function NewFooterComponent() {
  const companyLinks = [
    { label: "About us", path: "/company" },
    { label: "Blog", path: "https://essentialnews.ng/" },
  ];
  const resourceLinks = [
    { label: "Privacy", path: "/privacy" },
    { label: "Terms", path: "/terms" },
  ];
  const visitorData = useUserStat();
  const [formPassword, setFormPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [error, setError] = useState(false);

  const handleCheck = (e) => {
    e.preventDefault();
    if (formPassword === STAT_PASSWORD) {
      setPasswordMatch(true);
      return;
    }
    setError(true);
  };

  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-8 lg:px-16">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
        {/* Logo, Description, and Social Links Section */}
        <div className="md:col-span-1 flex flex-col items-start space-y-4">
          <img
            src={Logo}
            alt="eJobs Logo"
            className="w-28 sm:w-32 transition-transform hover:scale-105 duration-300"
          />
          <p className="text-sm sm:text-base text-gray-300 leading-relaxed max-w-xs">
            A vibrant community connecting job seekers and employers for seamless opportunities.
          </p>
          <SocialLinks />
        </div>

        {/* Company Links */}
        <div className="md:col-span-1 flex flex-col items-start space-y-3">
          <h3 className="text-base sm:text-lg font-semibold text-gray-100 mb-2">Company</h3>
          <ul className="space-y-2 text-gray-300">
            {companyLinks.map((link, index) => (
              <li key={index}>
                {link.path.startsWith('http') ? (
                  <a
                    href={link.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Resources Links */}
        <div className="md:col-span-1 flex flex-col items-start space-y-3">
          <h3 className="text-base sm:text-lg font-semibold text-gray-100 mb-2">Resources</h3>
          <ul className="space-y-2 text-gray-300">
            {resourceLinks.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.path}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter Section */}
        <div className="md:col-span-1 flex flex-col items-start space-y-4">
          <h2 className="text-base sm:text-lg font-semibold text-gray-100 mb-2">Stay Updated</h2>
          <div className="w-full max-w-xs space-y-3">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-2.5 bg-gray-800 text-white rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm sm:text-base"
            />
            <button className="w-full px-4 py-2.5 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-200 text-sm sm:text-base font-medium">
              Subscribe
            </button>
          </div>
        </div>

        {/* Copyright Section - Full Width */}
        <div className="md:col-span-4 pt-6 sm:pt-8 border-t border-gray-700">
          <Copyright />
        </div>
      </div>

      {/* Stats Section */}
      {/* <div className="mt-8 px-6">
        {passwordMatch ? (
          <Statistics
            visitorData={visitorData}
            setPasswordMatch={setPasswordMatch}
          />
        ) : (
          <StatsForm
            error={error}
            setFormPassword={setFormPassword}
            handleCheck={handleCheck}
          />
        )}
      </div> */}
    </footer>
  );
}

export default NewFooterComponent;